import './public-imports.js';

import {html} from 'lit';
import {customElement, state} from 'lit/decorators.js';
import {when} from 'lit/directives/when.js';
import B2bElement from '../b2b-element.js';

/* MTA JS Framework components */
import {fireErrorMessage} from '@mta/mta-js-framework/mta-message/mta-message';

import style from './b2b-public-styles.scss';
import '@mta/common-js/src/mta/common-mta-logo.js';
import './view/b2b-public-auth.js';
import './view/b2b-public-home.js';
import './view/error/access-denied.js';
import './view/b2b-public-sso.js';
import ExternalUserNotFoundException
  from "../gen/com/arabellesolutions/sdc/b2b/common/user/ExternalUserNotFoundException.js";
import CookieNotFoundException from "../gen/com/arabellesolutions/sdc/b2b/common/utils/CookieNotFoundException.js";
import B2bPublicServiceClientProxy from "../gen/com/arabellesolutions/sdc/b2b/pub/B2bPublicServiceClientProxy.js";

@customElement('b2b-public-app')
export class B2bPublicApp extends B2bElement {
  static styles = [style];

  /** @type {ExternalUser} */
  @state()
  accessor __b2bUser;

  @state()
  accessor __selectedPage;

  @state()
  accessor __title;

  @state()
  accessor __subTitle;

  __b2bPublicServiceProxy = new B2bPublicServiceClientProxy(super.msgpackClientPublic());

  render() {
    // language=HTML
    return html`
      <div class="page-container">
        <mta-message>
          ${when(!this.__isLoaded(), () => html`
              <h1>Loading</h1>
          `, () => html`
            
            <mta-page-lit
                bind-location
                use-hash-as-path
                fallback="home"
                pattern="/:page"
                @mta-page-title-changed="${this.__titleChanged}"
                .pages="${{
                  home: () => html`
                      <b2b-public-home .user="${this.__b2bUser}"></b2b-public-home>
                  `,
                  auth: routeData => html`
                    <b2b-public-auth .route="${routeData.tail}"></b2b-public-auth>
                  `, 
                  accessDenied: () => html`
                    <access-denied .user="${this.__b2bUser}"></access-denied>
                  `,
                  sso: routeData => html`
                    <b2b-public-sso .user="${this.__b2bUser}" .route="${routeData.tail}"></b2b-public-sso>
                  `
                }}">
            </mta-page-lit>
          `)}
        </mta-message>
      </div>
    `;
  }

  constructor() {
    super();

    this.__b2bPublicServiceProxy.getConnectedUser()
      .then(b2bUser => {
        this.__b2bUser = b2bUser;
      })
      .catch(e => {
        if (e instanceof ExternalUserNotFoundException) {
          this.__userNotFound = true;
        } else if (e instanceof CookieNotFoundException) {
          const hash = window.location.hash || '#/';
          const path = hash.replace(/^#/, '');
          // Only force redirect to login if we are NOT already on an /auth/* route
          if (!path.startsWith('/auth')) {
            this.redirect('#/auth/login');
          }
        } else {
          throw e;
        }
      });
  }

  __isLoaded() {
    return true;
  }

  displayErrorMessage(message) {
    fireErrorMessage(message, this.shadowRoot.querySelector('mta-message'));
  }

  __titleChanged(e) {
    document.title = `B2B | ${e.detail.title}`;
    this.__title = e.detail.title;
    this.__subTitle = e.detail.subTitle;
    this.__selectedPage = e.detail.pageName;
  }
}
